module.exports = {"632821100":"希里沟镇","632821101":"茶卡镇","632821102":"柯柯镇","632821103":"铜普镇","632821500":"海西州莫河畜牧场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632821.json
// module id = 3020
// module chunks = 0